import React, { useEffect } from "react";
import { NavContainer } from "./NavBarStyle";
import Logo from "../../Assets/logo.png";
import User from "../../Assets/user.png";
import { ImageController } from "../../Layouts/ImageController";
import { MenuOutlined } from "@mui/icons-material";
import NavLinks from "./NavLinks";
import { useDispatch, useSelector } from "react-redux";
import { IconButton } from "@mui/material";
import { toggleSmallSize, toggleSwitch } from "../../Redux/SwitchSlice";
const MainNavBar = ({ active, MAIN_USER }) => {
    const dispatch = useDispatch();
    const { smallSize } = useSelector((state) => state.switch);
    const smallSizeValue = smallSize;
    useEffect(() => {}, [smallSizeValue]);

    const handelToggle = () => {
        if (window.innerWidth <= 1200) dispatch(toggleSmallSize());
        else dispatch(toggleSwitch());
    };
    return (
        <>
            <NavContainer className={active ? "show" : ""}>
                <div>
                    <div className="prand center-flex">
                        {active && (
                            <ImageController
                                src={Logo}
                                alt="/"
                                width="100px"
                                objectFit="cover"
                            />
                        )}

                        <IconButton onClick={() => handelToggle()}>
                            <MenuOutlined />
                        </IconButton>
                    </div>
                    {active && (
                        <div className="user  left-flex">
                            <ImageController
                                src={
                                    MAIN_USER?.image_path
                                        ? MAIN_USER?.image_path
                                        : User
                                }
                                alt="/"
                                width="40px"
                                height="40px"
                                br="50%"
                                objectFit="cover"
                                m="0 .8rem 0 0"
                            />
                            <div className="data">
                                <h4>{MAIN_USER?.name}</h4>
                                <h6>{MAIN_USER?.Job_title}</h6>
                            </div>
                        </div>
                    )}
                </div>
                <div>
                    <NavLinks active={active} />
                </div>
            </NavContainer>
        </>
    );
};

export default MainNavBar;
